const storeAuthToken = (value) => {
    localStorage.setItem('authtoken', JSON.stringify(value))
  }

  const storeUserName = (value) => {
    localStorage.setItem('username', value)
  }
  const storeCurrentGRN = (value) => {
    localStorage.setItem('currentGrnId', value);
  }
  const storeUseremail = (value) => {
    localStorage.setItem('email', value)
  }
  const storeCompanyStatus = (value) => {
    localStorage.setItem('company', value)
  }
  
  const getAuthToken = () => {
    let data = localStorage.getItem('authtoken')
    return data ? JSON.parse(data) : null;
  }
  const getCurrentGRN = () => {
    let data = localStorage.getItem('currentGrnId')
    return data ? data : null;
  }

  const getUserName = () => {
    let data = localStorage.getItem('username')
    return data ;
  }
    const getUserEmail = () => {
    let data = localStorage.getItem('email')
    return data ;
  }
  const getCompanyStatus = () => {
    let data = localStorage.getItem('company')
    return data ;
  }
  const RMcurrentGrnId = () => {
     localStorage.removeItem('currentGrnId')
  }
  
  const removeAuthToken = () => {
    localStorage.removeItem('authtoken')
    localStorage.removeItem('username')
    localStorage.removeItem('company')
    localStorage.removeItem('pageHistory')
  }
  
  
  
  export { storeAuthToken, storeCurrentGRN, getAuthToken, removeAuthToken,storeUserName,storeUseremail,getUserName,getUserEmail,storeCompanyStatus,getCompanyStatus, getCurrentGRN, RMcurrentGrnId }
  